import { PUT_LOG, PUT_LOG_FAIL, PUT_LOG_SUCCESS } from 'actions/actionTypes';

export default (logMessage, type) => {
  const URL = `${API_HOST}/log/${type}`;
  return {
    types: [
      PUT_LOG,
      PUT_LOG_SUCCESS,
      PUT_LOG_FAIL,
    ],
    promise: (client) => client.put(URL, logMessage, { hideError: true }),
  };
};
